import AdminUsersScreen from '../../src/screens/AdminUsersScreen';

export default function AdminUsersRoute() {
  return <AdminUsersScreen />;
}
